
import NoticeModularService from '../notice-modular-service';
import FormulaAssetsInfo from '@/components/formula-assets-info/formula-assets-info.vue';
export default {
  components: {
    FormulaAssetsInfo
  },
  data () {
    return {
      id: '', // 标的id
      projectInfo: {},
      notice_time: '', // 公告时间
      type: 0, // 判断是转让还是采购
      transaction: {}, // 流转详情
      bidInfo: { detail: [] },
      citytitle: ''
    };
  },
  computed: {
    startTimeText () {
      const projectType = this.transaction.projectType;
      if (projectType === '6') {
        return '出租期限';
      }
      return '发包期限';
    },
    sumPlant () {
      let num = 0;
      this.bidInfo.detail.forEach(item => {
        // const obj = JSON.stringify(item.assetsInfo);
        if (item.forestList) {
          item.forestList.forEach(forestItem => {
            num += Number(forestItem.treeNumber);
          });
        }
      });
      return num;
    },
    projectCode () {
      if (this.transaction && this.transaction.projectType && this.transaction.projectSubType) {
        return `${this.transaction.projectType}-${this.transaction.projectSubType}`;
      }
    }
  },
  created () {
    this.id = this.$route.query.id;
    this.notice_time = this.$route.query.time;
    this.type = this.$route.query.type;
  },
  mounted () {
    if (this.$route.query.type === '1') {
      this.getAuctionResults();
    } else {
      // 集采
      this.getNoticeDetail();
    }
  },
  methods: {
    getNoticeDetail () {
      NoticeModularService.getFormulaProjectDetail(this.id).then(res => {
        if (res && res.code === '0') {
          this.projectInfo = res.data;
        }
      });
    },
    getAuctionResults () {
      NoticeModularService.getAuctionResults(this.id).then(res => {
        if (res && res.code === '0') {
          this.transaction = res.data;
          let arr = null;
          if (typeof res.data.projectAssets === 'string') {
            arr = JSON.parse(res.data.projectAssets);
          } else {
            arr = res.data.projectAssets;
          }
          // console.log(typeof res.data.projectAssets === 'string');
          console.log(arr);
          this.bidInfo = {
            detail: arr
          };
        }
      });
    }
  }
};
